module.exports = __webpack_public_path__ + "img/ticket_status03.8abc1c21.png";